class Booleans {
    static path = 'values/boolean';

    constructor(mutator){
        this.title = 'True or False';
        this.addOutput("true/false", "boolean");
        this.addProperty("value", 'TRUE');
        this.addWidget("combo","",'TRUE',{ property: "value", values: ['TRUE', 'FALSE'] } );
        this.bgcolor = '#bfb5b2';
        this.desc = 'A true or false value';
    }

    onExecute() {
        this.setOutputData(0, this.properties["value"]);
    }

    getTitle() {
        if (this.flags.collapsed) {
            return this.properties.value;
        }
        return this.title;
    }

    setValue(v) {
        this.setProperty("value",v);
    }

    onDrawBackground() {
        //show the current value
        this.outputs[0].label = this.properties["value"];
    }

}

module.exports = Booleans
